export const SORT_OPTIONS = ["Most common variant", "Fastest", "Slowest"];

export const VARIANTS_PER_PAGE = 10;